import firebase from "firebase/app"
import "firebase/auth"
import "firebase/firestore"
import "firebase/storage"
import { faker } from '@faker-js/faker';

const app = firebase.initializeApp({
  apiKey: "AIzaSyBcTa8sDNoejGyj3I79-JcjwT_N7tY6GB4",
  authDomain: "bpa-2023-web-application-team.firebaseapp.com",
  projectId: "bpa-2023-web-application-team",
  storageBucket: "bpa-2023-web-application-team.appspot.com",
  messagingSenderId: "844181674776",
  appId: "1:844181674776:web:1354fcc2fb565e0df4dc6d"
})

export const auth = app.auth()
export default app


export async function addUser(user) {
  // Get a reference to the "Users" collection
  var usersRef = firebase.firestore().collection("Users").doc(auth.currentUser.uid);

  // Add the new user to the "Users" collection
  await usersRef.set(user)
    .then(function(docRef) {
      console.log("User added with ID: ", docRef.id);
    })
    .catch(function(error) {
      console.error("Error adding user: ", error);
    });
}

export const createFakePosts = () => {
  var postsRef = firebase.firestore().collection("Posts");
  let catImage = faker.image.cats(640, 480, true);
  let profileImage = faker.image.avatar();
  let post = {
    country: faker.address.country(), 
    name: faker.name.fullName(),
    month: faker.date.month(),
    year: Math.floor(Math.random() * (2022 - 2010 + 1)) + 2010, 
    catImage: catImage,
    profileImage: profileImage, 
    catType: faker.animal.cat(),
  }

  // Add the new user to the "Users" collection
  postsRef.add(post)
    .then(function(docRef) {
      console.log("User added with ID: ", docRef.id);
    })
    .catch(function(error) {
      console.error("Error adding user: ", error);
    });
}

export function getRandomPosts() {
  var postsRef = firebase.firestore().collection("Posts").orderBy("year", "desc");
  var query = postsRef.limit(27);
  return query.get().then(snapshot => {
    var posts = [];
    snapshot.forEach(doc => {
      posts.push(doc.data());
    });
    return posts;
  });
}


export async function uploadImage(base64) {
  // Get a reference to the "Users" collection
  var storageRef = await firebase.storage().ref().child(`${auth.currentUser.uid}.png`);


  await storageRef.putString(base64, 'data_url')

  return await storageRef.getDownloadURL();
    
  
}


export const createPost = (data, imageLink, name) => {
  var postsRef = firebase.firestore().collection("Posts");
  let catImage = imageLink;
  let profileImage = 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png';
  let post = {
    country: 'United States', 
    name: name,
    month: getCurrentMonth(),
    year: (new Date()).getFullYear(), 
    catImage: catImage,
    profileImage: profileImage, 
    catType: data.catType,
  }

  postsRef.add(post)
    .then(function(docRef) {
      console.log("User added with ID: ", docRef.id);
    })
    .catch(function(error) {
      console.error("Error adding user: ", error);
    });
}


export const getUserDocument = async () => {
  var usersRef = firebase.firestore().collection("Users").doc(auth.currentUser.uid);
  const doc = await usersRef.get();
  return doc.data()
}


const getCurrentMonth = () => {
  var monthNames = ["January", "February", "March", "April", "May", "June",  "July", "August", "September", "October", "November", "December"];
  var currentMonthName = monthNames[(new Date()).getMonth()];
  return currentMonthName;
}

export async function deleteDocumentByName(name) {
  // Reference to your Firestore database
  const db = firebase.firestore();

  // Query to find documents with a name field equal to the given string
  const query = db.collection("Posts").where("name", "==", name);

  // Get the query snapshot
  const querySnapshot = await query.get();

  // Loop through the query snapshot and delete each document
  querySnapshot.forEach(function(doc) {
      doc.ref.delete();
  });
}
